import { DropDownModel } from "./drop-down-model";

export let CountryList: DropDownModel[] = [
    {
        view: 'USA',
        viewValue: 'USA'
    },
]
